module.exports = __webpack_public_path__ + "static/Le Coin Du Voile-b0bc4404035bebc50d864ed1c14fdbbf.mp3";